// API URL Configuration
// Like your other project's api.ts

// Export URL for use in hooks
export const url = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'production'
    ? 'https://agoracore360.com/api'
    : 'http://127.0.0.1:8000/api');

// Also export as API_BASE_URL for backward compatibility
export const API_BASE_URL = url;
